import { render, staticRenderFns } from "./ErrorDisplayComponent.vue?vue&type=template&id=0feb7b77&scoped=true"
import script from "./ErrorDisplayComponent.vue?vue&type=script&lang=js"
export * from "./ErrorDisplayComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feb7b77",
  null
  
)

export default component.exports